export default {
  changeLanguage: 'Sprache ändern',
  langEnglish: 'Englisch',
  langRussian: 'Russisch',
  langGerman: 'Deutsch',
  langChinese: 'Chinesisch',
  langUkraine: 'Ukrainisch'
}


// WEBPACK FOOTER //
// ./src/locale/de-DE/account.js